import { useMemo } from 'react';

import { useDataProvider } from '@work4all/data';

import { OutlookAddress } from '@work4all/models/lib/Classes/OutlookAddress.entity';
import { Supplier } from '@work4all/models/lib/Classes/Supplier.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { YELLOW_NOTE_FIELDS_QUERY } from '../yellow-note/yellow-note-fields';

export function useSupplier(id?: string) {
  const requestData = useMemo<DataRequest>(() => {
    const filter = [{ id: { $eq: id } }];

    return {
      entity: Entities.supplier,
      data: SUPPLIER_FIELDS,
      filter,
    };
  }, [id]);

  const { data, pending, refetch } = useDataProvider<Supplier>(
    requestData,
    !id
  );
  const supplier = data?.[0];
  const isSupplierValid = data?.length > 0;
  return { supplier, pending, refetch, isSupplierValid };
}

const personalContactMappings: OutlookAddress<EMode.query>[] = [
  {
    id: null,
    contactId: null,
    userId: null,
    sdObjMemberId: null,
    sdObjType: null,
    modificationDate: null,
    updateTime: null,
    insertTime: null,
    user: {
      id: null,
      displayName: null,
    },
  },
];

const SUPPLIER_FIELDS: Supplier<EMode.query> = {
  id: null,
  name: null,
  number: null,
  languageId: null,
  phoneNumber: null,
  phoneNumber2: null,
  isPrivateCustomer: null,
  eMail: null,
  eMail2: null,
  locked: null,
  mainContactId: null,
  street: null,
  city: null,
  postalCode: null,
  website: null,
  note: null,
  group: { id: null, name: null },
  paymentKind: { id: null, longtext: null },
  firstContactDate: null,
  firstContactPerson: null,
  paymentDeadline: null,
  skonto: null,
  skonto2: null,
  skontoDurationDays: null,
  skonto2DurationDays: null,
  postOfficeBox: null,
  postOfficeBoxLocation: null,
  postOfficeBoxPostalCode: null,
  kpis: {
    dueOpenValue: null,
    salesValues: [
      {
        fromDate: null,
        toDate: null,
        value: null,
      },
    ],
    vacantPositions: null,
  },
  postIt: YELLOW_NOTE_FIELDS_QUERY,
  categoryAssignmentList: [
    {
      id: null,
      categoryId: null,
      categoryKindName: null,
      categoryName: null,
    },
  ],
  personalContactMappings,
  contactList: [
    {
      id: null,
      displayName: null,
      phoneNumber: null,
      phoneNumber2: null,
      phoneNumber3: null,
      phoneNumberPrivate: null,
      mobileNumber: null,
      isMainContact: null,
      mobileNumberPrivate: null,
      eMail: null,
      eMailPrivate: null,
      layedOff: null,
      showFunctionInAddress: null,
      showDepartmentInAddress: null,
      departmentId: null,
      department: {
        id: null,
        customerId: null,
        supplierId: null,
        name: null,
        insertTime: null,
        updateTime: null,
      },
      role: null,
      salutation: {
        id: null,
        isMale: null,
        isFemale: null,
      },
      firstName: null,
      note: null,
      name: null,
      businessPartnerType: null,
      businessPartnerId: null,
      businessPartner: {
        id: null,
        data: {
          supplier: { id: null, name: null },
        },
      },
      categoryAssignmentList: [
        {
          id: null,
          categoryId: null,
          categoryKindName: null,
          categoryName: null,
        },
      ],
      attachements: [
        {
          id: null,
          index: null,
          objMemberCode: null,
          type: null,
          fileInfos: {
            fileEntityFilename: null,
            downloadUrl: null,
            previewUrl: null,
            fileRequestType: null,
            downloadMimeType: null,
            previewMimeType: null,
            fileSize: null,
          },
        },
      ],
      personalContactMappings,
    },
  ],
  extinct: null,
  objectGroupProtectionState: null,
  objectGroups: [
    {
      id: null,
      name: null,
      grIndex: null,
      grLevel: null,
    },
  ],
  mobileNumber: null,
};
